import { render, staticRenderFns } from "./MonitoringEstablishments.vue?vue&type=template&id=4a2e5674&scoped=true&"
import script from "./MonitoringEstablishments.vue?vue&type=script&lang=js&"
export * from "./MonitoringEstablishments.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringEstablishments.vue?vue&type=style&index=0&id=4a2e5674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e5674",
  null
  
)

export default component.exports